/**
 * Given an array of images, it will merge them on a canvas and return the data url of the canvas
 */
export async function mergeImages(images: string[], height: number, width: number) {
    // Create a canvas for the images to be rendered on
    const screenshotCanvas = document.createElement("canvas");
    screenshotCanvas.height = height;
    screenshotCanvas.width = width;
    const screenshotCanvasCtx = screenshotCanvas.getContext("2d");

    // For each image, load it and render it on a canvas
    for (const image of images) {
        const htmlImageElement = await new Promise<HTMLImageElement>((res) => {
            const imageElement = document.createElement("img");
            imageElement.onload = () => {
                res(imageElement);
            };
            imageElement.src = image;
        });
        screenshotCanvasCtx.drawImage(htmlImageElement, 0, 0);
    }

    return screenshotCanvas.toDataURL();
}
